import { Discussion } from './Discussion';
import type { DiscussionClient } from './Discussion';
import { useLang } from '../i18n/lang';

/*
 * THE DISCUSSION, AS ITS OWN DRAWER.
 *
 * It used to sit at the very bottom of the node panel, under every passage — so reaching the
 * conversation about a figure meant scrolling past everything the figure is. Here it is a panel of
 * its own, side by side with the reading, opened when the reader wants it: the composer at the top,
 * the notes scrolling below, and the same read-anonymously / participate-signed-in rule intact. The
 * chat itself is unchanged; this is where it lives and how it is reached that changed.
 */
export interface DiscussionDrawerProps {
  client: DiscussionClient;
  /** Our own id, so a reader can tell which words are theirs. Null when signed out. */
  meId: string | null;
  /** The node whose discussion this is. */
  nodeId: string;
  /** The figure's name, for the heading. */
  title: string;
  onClose: () => void;
}

export function DiscussionDrawer({ client, nodeId, title, meId, onClose }: DiscussionDrawerProps): React.JSX.Element {
  const { t } = useLang();
  return (
    <aside className="discussion-drawer" role="region" aria-label={t('discussionDrawer.label', { title })}>
      <div className="discussion-head">
        <h2 className="discussion-title">{t('discussionDrawer.heading', { title })}</h2>
        <button type="button" className="discussion-close" onClick={onClose} aria-label={t('action.close')}>×</button>
      </div>
      <Discussion client={client} nodeId={nodeId} meId={meId} />
    </aside>
  );
}
